import { module } from 'modujs';
import modularLoad from 'modularload';
import { html, body } from '../utils/environment';
import { gsap } from 'gsap';

export default class extends module {
    constructor(m) {
        super(m);
    }

    init() {
        this.setSizes();

        const load = new modularLoad({
            enterDelay: 1500,
            exitDelay: 1500,
            transitions: {

            }
        });

        load.on('loading', (transition, oldContainer) => {
            html.classList.remove('has-dom-ready');
            html.classList.remove('has-dom-ready-callback');
            html.classList.remove('has-dom-animated');
            html.classList.remove('has-nav-open');

            html.classList.add('is-preloading');

            html.setAttribute('data-theme','');
        });

        load.on('loaded', (transition, oldContainer, newContainer) => {
            this.call('destroy', oldContainer, 'app');
            this.call('update', newContainer, 'app');

            gsap.delayedCall(window.readyDelay,() => {
                html.classList.remove('is-preloading');
                html.classList.add('has-dom-ready');
        
                gsap.delayedCall(window.readyCallbackDelay,() => {
                    html.classList.add('has-dom-ready-callback');
                    html.classList.add('has-dom-animated');
                });
                
            })
        });
    }

    setSizes() {
        
        if (window.innerHeight - document.documentElement.clientHeight > 0) {
            body.classList.add('has-scrollbar-y');
            document.documentElement.style.setProperty('--scrollbar',`${window.innerHeight - document.documentElement.clientHeight}px`);
        } else {
            body.classList.remove('has-scrollbar-y');
        }

        // screen height
        document.documentElement.style.setProperty('--app-availheight',`${window.screen.availHeight}px`);
        document.documentElement.style.setProperty('--app-height',`${window.innerHeight}px`);
        document.documentElement.style.setProperty('--app-height-negative',`-${window.innerHeight}px`);

        window.addEventListener('resize',() => {

            if(!window.isMobile) {
                document.documentElement.style.setProperty('--app-availheight',`${window.screen.availHeight}px`);
                document.documentElement.style.setProperty('--app-height',`${window.innerHeight}px`);
                document.documentElement.style.setProperty('--app-height-negative',`-${window.innerHeight}px`);
            }
        });
    }
}
